export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

function text(value: unknown): string | null {
  return typeof value === 'string' && value.trim() && value !== '[object Object]' ? value : null;
}

/** Pull a human-readable message out of a Wagner/Fjell error body. */
export function apiErrorMessage(body: unknown, status: number): string {
  const record = body && typeof body === 'object' ? body as Record<string, unknown> : {};
  const error = record.error && typeof record.error === 'object' ? record.error as Record<string, unknown> : null;
  const raw = text(record.message)
    || text(error?.message)
    || text(record.error)
    || `API request failed (${status})`;
  if (status === 401 && /jwt expired/i.test(raw)) return 'Your Google session expired. Sign in again.';
  return raw;
}
